<template>
  <b-card class="flex-column flex-md-row" header-class="bg-white border-0" no-body v-if="details">
    <b-img v-if="details.image" class="card-img-left" :src="details.image | cdn('resize', 500, 200)"/>
    <b-card-body>
      <h3>{{ details.title }}</h3>
      <h4>{{ details.description }}</h4>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  // To make testing this easier, allow the companyHandle to be changed
  ...(process.env.NODE_ENV !== 'production' ? {
    data: () => ({ companyHandle: null }),
    created() {
      const { company } = this.$root;
      this.companyHandle = (company || {}).handle || null;
    },
  } : {}),
  computed: {
    // And in production, stop companyHandle from being changed
    ...(process.env.NODE_ENV === 'production' ? mapRoot({
      companyHandle: ({ company }) => (company || {}).handle || null,
    }) : {}),
    details() {
      switch (this.companyHandle) {

        case 'real-links-demo': return {
          image: 'https://real-links-assets.s3-eu-west-2.amazonaws.com/real-links-demo-PVEWQ/2020-09-24/3ee8bac1-4a9f-4cc8-9d5f-84be137bec3a/4-k-tv.jpg',
          title: 'Earn 20 tickets for connecting your networks with the platform!',
          description: 'If you win the raffle this month, you could win a 4K UHD TV, Apple AirPods or a bottle of Moet &amp; Chandon!',
        };

        case 'sainsburys': return {
          image: 'https://real-links-assets.s3-eu-west-2.amazonaws.com/sainsburys-AVpdV/2020-11-09/8181c4d8-8393-433a-8f83-153fad32bf90/love-blank.png',
          title: 'Earn 20 tickets for connecting your networks with the platform!',
          description: 'If you win the raffle this month, you could win up to £250 of love it vouchers!',
        };

        default: return null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contacts-upload/Promo.vue